module.exports = __webpack_public_path__ + "static/absolute-header-structure@2x-71a2faf4bac0d6791aaa0817bbf79d2e.jpg";